import React, { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

// Parses a display value like "$300M+", "24%", "96" and animates the numeric part.
export const StatCounter = ({ value, label, note, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [display, setDisplay] = useState(0);

  const match = String(value).match(/([^0-9.]*)([0-9.,]+)(.*)/);
  const prefix = match ? match[1] : "";
  const target = match ? parseFloat(match[2].replace(/,/g, "")) : 0;
  const suffix = match ? match[3] : "";
  const decimals = match && match[2].includes(".") ? 1 : 0;

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const dur = 1400;
    const tick = (now) => {
      const p = Math.min((now - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(target * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, target]);

  const formatted =
    target >= 1000 ? Math.round(display).toLocaleString() : display.toFixed(decimals);

  return (
    <div ref={ref} className={className}>
      <div className="font-display text-4xl font-semibold tracking-tight text-foreground sm:text-5xl">
        <span className="text-primary">{prefix}</span>
        {formatted}
        <span className="text-primary">{suffix}</span>
      </div>
      <div className="mt-2 text-sm font-medium text-foreground/90">{label}</div>
      {note && <div className="mt-0.5 font-mono text-xs text-muted-foreground">{note}</div>}
    </div>
  );
};
